import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import {
  AgGridUtility,
  CommonUtility,
  DataService,
  DateUtility,
  DOUBLE_ROW_HEADER,
  ServerConstantsService
} from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { HttpClient } from '@angular/common/http';
import { GridOptions } from 'ag-grid';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-employment-summary',
  templateUrl: './employment-summary.component.html',
  styleUrls: ['./employment-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class EmploymentSummaryComponent implements OnInit {
  serverConstants: any;
  sharedData: any;
  refData: any;
  userActionNotificationsMap: any;
  employmentTypeCd: any;
  employmentTypeMap: any;
  employmentTypeJson: any;
  employmentHistory: EmploymentHistory[] = [];

  /*Grid Table*/
  columnDefs: any;
  context: any;
  gridOptions: GridOptions;
  gridApi;
  firstTime: Boolean = true;

  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  ssnValue;
  isUniverse = false;

  @ViewChild('headerText') headerText: ElementRef;

  constructor(private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    private data: ReferenceTableService,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private agGridUtility: AgGridUtility,
    private datePipe: DatePipe,
    private serverConstantsService: ServerConstantsService) {
    this.gridOptions = <GridOptions>{};
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('CLINF') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    this.sharedData = this.dataService.getSharedDataObject();
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');
    this.ssnValue = this.sharedData.get('SSN_SEARCH');
    this.parseRefTableData();
    this.getColumnDefinitions();
    this.employmentHistory = [];
    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadFromAries(this.sharedData.get('personProvider').emciId) : this.load();
  }

  load() {

    this.http.get<EmploymentHistory[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetClientEmploymentHistory/'
      + this.ssnValue).subscribe(
        (data: EmploymentHistory[]) => {
          if (data !== null && data !== undefined && data.length > 0) {
            this.employmentHistory = data;
            this.employmentHistory.sort((a, b) => new Date(b.START_DT).getTime() - new Date(a.START_DT).getTime());
            this.employmentHistory.forEach(rows => {
              if (rows.START_DT !== undefined && rows.START_DT !== null) {
              rows.START_DT = this.dateUtil.formatDate(rows.START_DT);
              }
              if (rows.END_DT !== undefined && rows.END_DT !== null) {
                rows.END_DT = this.dateUtil.formatDate(rows.END_DT);
              }
            });
          } else {
            this.notificationService.warn('Universe Search', 'Employment History Information not found in Eligibility System');
            this.employmentHistory = [];
          }
        },
        response => {
          this.notificationService.error('Universe Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  loadFromAries(emciId) {

    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/Aries/empInfo/' + emciId).subscribe(
      (data: Array<Object>) => {
        if(data.length > 0){
          let empList=[];
          data.forEach((element)=>{
            let record = {
              EMPLOYER_NAME:null,
              EMPLOYMENT_TYPE:null,
              START_DT:null,
              END_DT:null
            }
            if(element["employer"] != null){
              record.EMPLOYER_NAME = element["employer"];
            }
            /*if(element["EMP_TYPE"] != null && this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]) != undefined){
              record.employmentType = this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]).name;
            }
            else{
              record.employmentType = element["EMP_TYPE"];
            }*/
            if(element["effBeginDt"] != null){
              // record.employmentStartdate = element["EMP_START"].toString().split(" ")[0];
              record.START_DT= this.datePipe.transform(new Date(element["effBeginDt"]), 'yyyy/MM/dd');
            }
            if(element["effEndDate"] != null){
              //record.employmentEnddate = element["EMP_END"].toString().split(" ")[0];
              record.END_DT= this.datePipe.transform(new Date(element["effEndDate"]), 'yyyy/MM/dd');
            }
            if(record.EMPLOYER_NAME != null){
              empList.push(record);
            }
                    
          });
          this.employmentHistory = empList;
        }
        else {
          this.notificationService.warn('Universe Search', 'Employment History Information not found in Eligibility System');
          this.employmentHistory = [];
        }
      },
      response => {
        this.notificationService.error('Universe Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });


  }

  onGridReady(params) {
    this.gridOptions.api = params.api;
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    } else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Employer',
        field: 'EMPLOYER_NAME',
        cellStyle: { 'white-space': 'normal' },
      },
      {
        headerName: 'Employment Type',
        field: 'EMPLOYMENT_TYPE',
        cellStyle: { 'white-space': 'normal' }
      },
      {
        headerName: 'Employment Start Date',
        field: 'START_DT',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
      },
      {
        headerName: 'Employment End Date',
        field: 'END_DT',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        }
      }
    ];

    this.context = {
      component: this,
    };
  }

  getEmploymentType(params) {
    const that = params.context.component;
    let employmentType = that.convertCode(that.employmentTypeMap, params.data.employmentTypeCd);
    if (employmentType === undefined) {
      employmentType = '';
    }
    return employmentType;
  }


  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  parseRefTableData() {
    this.userActionNotificationsMap =
      this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.employmentTypeCd = this.data.getValueFromSharedDataMap('EmploymentType');
    this.employmentTypeMap = this.commonUtil.createMapFromList(this.employmentTypeCd);
    this.employmentTypeJson = this.commonUtil.createNativeMapFromList(this.employmentTypeCd);
  }

  focusSummary(e: KeyboardEvent) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    if (this.employmentHistory.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  focusing(event){
    if ( !event.shiftKey && event.keyCode === 9 ) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  gridClick() {
    this.firstTime = false;
  }
}

export class EmploymentHistory {
  constructor(
    public EMPLOYER_NAME?: string,
    public EMPLOYMENT_TYPE?: string,
    public START_DT?: string,
    public END_DT?: string
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/employment-summary/employment-summary.component.ts